/* eslint-disable import/prefer-default-export */

import {
  SELECTED_VENUE_OWNERSHIP_CHANGED,
  VENUE_OWNERSHIP_UPDATED,
  SEATING_SETTINGS_UPDATED,
  CUSTOM_FIELDS_CHANGED
} from '../constants/ticketingSettingsConstants';

const axios = require('axios').default;

import { toast } from 'react-toastify';

export const selectedVenueOwnershipChanged = (venueOwnership) => ({
  type: SELECTED_VENUE_OWNERSHIP_CHANGED,
  venueOwnership
});

export const updateVenueOwnership = (dispatch, csrfToken, team, venueOwnership) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    const formData = new FormData();

    const venueOwnershipParams = {
      ticket_confirmation_info: venueOwnership.ticket_confirmation_info,
      statement_descriptor_suffix: venueOwnership.statement_descriptor_suffix,
      max_tickets_per_email: venueOwnership.max_tickets_per_email || 0,
      google_tracking_id: (venueOwnership.google_tracking_id ? venueOwnership.google_tracking_id : ""),
      facebook_pixel_id: (venueOwnership.facebook_pixel_id ? venueOwnership.facebook_pixel_id : ""),
      reddit_pixel_id: (venueOwnership.reddit_pixel_id ? venueOwnership.reddit_pixel_id : ""),
      default_ticketing_arrangement: venueOwnership.default_ticketing_arrangement,
      enable_all_in_pricing: venueOwnership.enable_all_in_pricing,
      checkout_captcha_default_on: venueOwnership.checkout_captcha_default_on || false,
      delivery_type: venueOwnership.delivery_type,
      delivery_time_interval: venueOwnership.delivery_time_interval,
      delivery_time_unit: venueOwnership.delivery_time_unit,
      website_image_ratio: venueOwnership.website_image_ratio,
      ratio_cropped_emails_enabled: venueOwnership.ratio_cropped_emails_enabled || false,
      show_sponsor_on_digital_tickets: venueOwnership.show_sponsor_on_digital_tickets || false,
      sponsor_name: venueOwnership.sponsor_name || "",
      show_fee_breakdown_on_ticket_price: venueOwnership.show_fee_breakdown_on_ticket_price,
      include_taxes_in_all_in_pricing: venueOwnership.include_taxes_in_all_in_pricing || false,
      default_round_up_ticket_types: venueOwnership.default_round_up_ticket_types || false,
      default_round_up_add_ons: venueOwnership.default_round_up_add_ons || false,
      default_dynamic_pricing_ticket_types: venueOwnership.default_dynamic_pricing_ticket_types || false,
      default_dynamic_pricing_add_ons: venueOwnership.default_dynamic_pricing_add_ons || false
    };

    Object.keys(venueOwnershipParams).forEach(key => {
      formData.append(`venue_ownership[${key}]`, venueOwnershipParams[key]);
    });

    if (venueOwnership.destroy_sponsor_logo === true) {
      formData.append('venue_ownership[destroy_sponsor_logo]', 'true');
    }

    if (venueOwnership.sponsor_logo && venueOwnership.sponsor_logo instanceof File) {
      formData.append('venue_ownership[sponsor_logo]', venueOwnership.sponsor_logo);
    }

    return axios.patch("/teams/" + team.id + "/venue_ownerships/" + venueOwnership.id, formData)
      .then(({ data }) => {
        dispatch(venueOwnershipUpdated(data));

        toast.success("Settings successfully updated", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const venueOwnershipUpdated = (venueOwnership) => ({
  type: VENUE_OWNERSHIP_UPDATED,
  venueOwnership
});

export const customFieldsChanged = (venueOwnershipId, customFields) => ({
  type: CUSTOM_FIELDS_CHANGED,
  venueOwnershipId,
  customFields
});

export const seatingSettingsUpdated = (venueOwnershipId, seatingData) => ({
  type: SEATING_SETTINGS_UPDATED,
  venueOwnershipId,
  seatingData
});
